import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Trucks.css';

function Trucks() {
  const [showAllManufacturers, setShowAllManufacturers] = useState(false); // State to manage manufacturer visibility

  const toggleShowManufacturers = () => {
    setShowAllManufacturers(!showAllManufacturers); // Toggle visibility
  };
  // --- Begin make/model filter code ---
  const [make, setMake] = useState('');
  const [model, setModel] = useState('');
  const [makes, setMakes] = useState([]);
  const [models, setModels] = useState([]);
  const navigate = useNavigate();

  // Fetch distinct truck makes on mount
  useEffect(() => {
    axios.get('/api/vehicles/distinct/truck')
      .then(res => setMakes(res.data.make.sort()))
      .catch(err => console.error('Error fetching makes:', err));
  }, []);

  // Fetch models when a make is selected
  useEffect(() => {
    if (!make) {
      setModels([]);
      setModel('');
      return;
    }
    axios.get(`/api/vehicles/distinct/truck?make=${encodeURIComponent(make)}`)
      .then(res => setModels(res.data.model.sort()))
      .catch(err => console.error('Error fetching models:', err));
  }, [make]);

  const handleMakeChange = (e) => setMake(e.target.value);
  const handleModelChange = (e) => setModel(e.target.value);
  const handleSearch = (e) => {
    e.preventDefault();
    const parts = [];
    if (make) parts.push(`make=${encodeURIComponent(make)}`);
    if (model) parts.push(`model=${encodeURIComponent(model)}`);
    navigate(`/truck-search?${parts.join('&')}`);
  };
  // --- End make/model filter code ---
  return (
    <div className="trucks-page">
      {/* Hero Section */}
      <section className="trucks-hero">
        <h2>Find new & used trucks</h2>
        <form className="trucks-search-form" onSubmit={handleSearch}>
          <select name="make" value={make} onChange={handleMakeChange}>
            <option value="">Make</option>
            {makes.map(m => (
              <option key={m} value={m}>{m}</option>
            ))}
          </select>
          <select name="model" value={model} onChange={handleModelChange} disabled={!make}>
            <option value="">Model</option>
            {models.map(mo => (
              <option key={mo} value={mo}>{mo}</option>
            ))}
          </select>
          <button type="submit" className="cta-button">Search Trucks</button>
        </form>
      </section>

      {/* Latest Adverts Section */}
      <section className="latest-adverts">
        <h2>Latest adverts</h2>
        <div className="adverts-grid">
          <div className="advert-card">DAF CF</div>
          <div className="advert-card">Montracon Tri Axle Trailer</div>
          <div className="advert-card">Mercedes-Benz Actros</div>
          <div className="advert-card">SDC Other</div>
        </div>
      </section>

      {/* Truck Services Section */}
      <section className="truck-services">
        <h2>Truck services and products</h2>
        <div className="services-grid">
          <div className="service-card">Commercial Truck Exports</div>
          <div className="service-card">Truck Parts & Accessories</div>
          <div className="service-card">Truck Rental, Hire & Lease</div>
        </div>
      </section>

      {/* Truck Manufacturers Section */}
      <section className="truck-manufacturers">
        <h2>Truck manufacturers and their models</h2>
        <div className="manufacturers-grid">
          <div className="manufacturer-card">
            <img src={require('../assets/logos/scania-logo.jpg')} alt="Scania Logo" />
            <span>Scania</span>
          </div>
          <div className="manufacturer-card">
            <img src={require('../assets/logos/volvo-logo.jpg')} alt="Volvo Logo" />
            <span>Volvo</span>
          </div>
          <div className="manufacturer-card">
            <img src={require('../assets/logos/mercedes-logo.jpg')} alt="Mercedes-Benz Logo" />
            <span>Mercedes-Benz</span>
          </div>
          <div className="manufacturer-card">
            <img src={require('../assets/logos/daf-logo.jpg')} alt="DAF Logo" />
            <span>DAF</span>
          </div>
          {showAllManufacturers && (
            <>
              {/* Additional manufacturers */}
              <div className="manufacturer-card">
                <img src={require('../assets/logos/isuzu-logo.jpg')} alt="Isuzu Logo" />
                <span>Isuzu</span>
              </div>
              <div className="manufacturer-card">
                <img src={require('../assets/logos/iveco-logo.jpg')} alt="Iveco Logo" />
                <span>Iveco</span>
              </div>
              <div className="manufacturer-card">
                <img src={require('../assets/logos/man-logo.jpg')} alt="MAN Logo" />
                <span>MAN</span>
              </div>
              <div className="manufacturer-card">
                <img src={require('../assets/logos/mitsubishi-logo.jpg')} alt="Mitsubishi Logo" />
                <span>Mitsubishi</span>
              </div>
              <div className="manufacturer-card">
                <img src={require('../assets/logos/renault-logo.jpg')} alt="Renault Logo" />
                <span>Renault</span>
              </div>
              {/* Add more manufacturers as needed */}
            </>
          )}
        </div>
        <button onClick={toggleShowManufacturers} className="view-all-manufacturers-btn">
          {showAllManufacturers ? 'Hide all manufacturers' : 'Show all manufacturers'}
        </button>
      </section>

      {/* Social Media Section */}
      <section className="social-media">
        <h2>Follow us on social media</h2>
        <p>All the latest news for you</p>
        <div className="social-links">
          <a href="#" className="social-icon">Facebook</a>
          <a href="#" className="social-icon">YouTube</a>
          <a href="#" className="social-icon">Instagram</a>
          <a href="#" className="social-icon">TikTok</a>
        </div>
      </section>
    </div>
  );
}

export default Trucks;
